import QRCode from 'qrcode';

export function qrCodeGenerate(data: string): Promise<string> {
  return new Promise<string>((resolve) => {
    QRCode.toDataURL(data, (_err, url: string) => {
      resolve(url);
    });
  });
}
